import { useMutation } from "@tanstack/react-query";
import { getArtifactsApiClient } from "@shared/apis/sidekick/api-factories";
import { FindListingsAv8Request } from "@shared/apis/sidekick/generated";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  artifactId: string;
  input: FindListingsAv8Request;
};

export const useUpdateWidgetArtifact = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getArtifactsApiClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { artifactId, input } = params;
      const response = await api.artifactControllerUpdate({
        artifactId,
        updateArtifactDto: {
          content: {
            artifactId,
            arguments: input,
          },
        },
      });
      onSuccess?.();
      return response;
    },
    onError: async (error, { artifactId }) => {
      console.error(`Failed to update artifact with id ${artifactId}`, error);
    },
  });

  return mutation;
};
